import { Icon } from '@/components/icon';
import { useState, type VFC } from 'react';
import { Button } from 'components';
import { Modal, Typography, Input } from 'antd';
import type { Job } from '@enmon/commons/lib/tools';

interface AsyncJobDetailsProps {
  data: unknown;
  fail_reason: Job['fail_reason'];
}

export const AsyncJobDetails: VFC<AsyncJobDetailsProps> = ({ data, fail_reason }) => {
  const [isModalOpened, setIsModalOpened] = useState(false);
  return (
    <>
      <Modal
        closable
        cancelButtonProps={{ style: { display: 'none' } }}
        okText="Close"
        open={isModalOpened}
        width={800}
        onCancel={() => setIsModalOpened(false)}
        onOk={() => setIsModalOpened(false)}
      >
        {data && (
          <>
            <Typography.Title level={5}>Job data</Typography.Title>
            <Input.TextArea rows={24} value={JSON.stringify(data, null, 2)} />
          </>
        )}
        {fail_reason && (
          <>
            <Typography.Title level={5}>Fail reason</Typography.Title>
            <Input.TextArea rows={16} value={fail_reason} />
          </>
        )}
      </Modal>
      <Button icon={<Icon iconString="info" />} onClick={() => setIsModalOpened(true)} />
    </>
  );
};
